var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupedBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 41,
    viewBox: "0 0 58 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1274 7.51339L1.11443 2.74752L31.378 2.63065C31.6102 2.62976 31.7987 2.75835 31.7991 2.91787L31.8105 7.10606C31.811 7.26559 31.6231 7.39563 31.391 7.39653L1.1274 7.51339Z",
    fill: "#003F7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14293 12.9726L1.12997 8.20675L41.0438 8.05262C41.2722 8.05174 41.4577 8.18034 41.4582 8.33987L41.4696 12.5281C41.47 12.6876 41.2852 12.8176 41.0567 12.8185L1.14293 12.9726Z",
    fill: "#0069D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15924 18.4768L1.14627 13.7109L51.5771 13.5161C51.8073 13.5152 51.9942 13.6438 51.9947 13.8034L52.0061 17.9916C52.0065 18.1511 51.8203 18.2811 51.5901 18.282L1.15924 18.4768Z",
    fill: "#0298A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53638 27.5638L1.52342 22.7979L23.2769 22.7139C23.5272 22.7129 23.7305 22.8415 23.7309 23.001L23.7423 27.1892C23.7427 27.3487 23.5402 27.4788 23.2899 27.4798L1.53638 27.5638Z",
    fill: "#003F7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55292 32.9672L1.53995 28.2013L31.0102 28.0875C31.2645 28.0865 31.4711 28.215 31.4715 28.3745L31.4829 32.5627C31.4833 32.7223 31.2775 32.8524 31.0232 32.8533L1.55292 32.9672Z",
    fill: "#0069D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56933 38.4003L1.55637 33.6344L38.7492 33.4908C39.0043 33.4898 39.2115 33.6183 39.212 33.7779L39.2234 37.966C39.2238 38.1256 39.0173 38.2557 38.7621 38.2567L1.56933 38.4003Z",
    fill: "#0298A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12683 0.843384L1.25649 40.8432",
    stroke: "#2B2B35",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupedBar);
export default __webpack_public_path__ + "static/media/grouped_bar.a47430f2e919e8ac4a1718b5a43b82e9.svg";
export { ForwardRef as ReactComponent };